import React from 'react';
import AppLogo from './AppLogo';

/**
 * Minimal, reusable install banner.
 *
 * - For supported browsers (Android/desktop Chromium): shows an Install button (uses native prompt).
 * - For iOS (any browser): shows manual guidance (Share → Add to Home Screen) because iOS doesn't fire `beforeinstallprompt`.
 * - Dismiss is handled by the parent so it can be persisted (localStorage).
 */
export default function InstallBanner({ variant, onInstall, onDismiss }) {
  if (variant === 'none') return null;

  const message =
    variant === 'prompt'
      ? 'Install SustainabilityHub for a faster, app-like experience.'
      : 'Tap Share → Add to Home Screen';

  return (
    <div className="px-4 pt-3">
      <div className="bg-white border border-emerald-100/70 rounded-xl px-3 py-3 shadow-sm">
        <div className="flex items-start gap-3">
          <div className="p-2 bg-green-100 rounded-lg flex items-center justify-center shrink-0">
            <AppLogo className="h-6 w-6 object-contain" />
          </div>

          <div className="min-w-0 flex-1">
            <div className="text-sm text-gray-900 font-semibold leading-snug">{message}</div>
            {variant === 'ios' ? (
              <div className="mt-1 text-xs text-gray-600">
                (On iPhone/iPad — installed apps open from your home screen)
              </div>
            ) : null}
          </div>

          <div className="flex items-center gap-2 shrink-0">
            {variant === 'prompt' ? (
              <button
                type="button"
                onClick={onInstall}
                className="px-3 py-1.5 text-xs font-semibold rounded-full bg-emerald-600 text-white hover:bg-emerald-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500 focus-visible:ring-offset-2"
              >
                Install App
              </button>
            ) : null}

            <button
              type="button"
              onClick={onDismiss}
              className="h-8 w-8 grid place-items-center rounded-full text-gray-500 hover:text-gray-800 hover:bg-gray-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500 focus-visible:ring-offset-2"
              aria-label="Dismiss install banner"
              title="Dismiss"
            >
              <span className="text-lg leading-none">×</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

